import ApiService from "@/utils/request"

export const LiaisonServe = {
  list(params) {
    return ApiService.query("gf/liaison", params)
  }
}

export const GFLogServe = {
  list(params) {
    return ApiService.query("gf/assist/log/year", params)
  },
  getDivisionWZ() {
    return ApiService.query(`alumni/division/wenzhou`)
  },
  create(params, uuid) {
    return ApiService.post(`gf/assist/log?uuid=${uuid}`, params)
  },
  update(params, uuid) {
    const { id } = params
    return ApiService.put(`gf/assist/log/${id}?uuid=${uuid}`, params)
  },
  details(id, uuid) {
    return ApiService.query(`gf/assist/log/${id}`, { uuid })
  }
}
